module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel"
  }, [_c('ul', {
    staticClass: "container",
    style: ({
      left: '-' + _vm.x,
      width: _vm.answers.length * 100 + 'vw'
    }),
    on: {
      "click": _vm.closeCarousel
    }
  }, [_vm._l((_vm.answers), function(answer, index) {
    return _c('li', [_c('div', {
      staticClass: "card",
      class: {
        'correct': answer.points
      }
    }, [_c('span', {
      staticClass: "close",
      on: {
        "click": function($event) {
          _vm.$store.dispatch('HIDE_CAROUSEL')
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "action"
    }, [_c('span', [_vm._v("actie " + _vm._s(index + 1) + " / " + _vm._s(_vm.answers.length))])]), _vm._v(" "), _c('div', {
      staticClass: "ac-question"
    }, [_vm._v(_vm._s(answer.question))]), _vm._v(" "), _c('div', {
      staticClass: "answer"
    }, [_vm._v("Jij zei: "), _c('span', [_vm._v(_vm._s(answer.answer))]), _c('span', {
      staticClass: "points"
    }, [_c('span', [_vm._v(_vm._s(answer.points))]), _vm._v(" punten")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('span', {
    staticClass: "arrow arrow-left",
    class: {
      'hidden': _vm.$store.state.carousel.active == 0
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('PREVIOUS_CAROUSEL_ITEM')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "arrow arrow-right",
    class: {
      'hidden': _vm.$store.state.carousel.active == this.answers.length - 1
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('NEXT_CAROUSEL_ITEM')
      }
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d3a45ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 115
// module chunks = 1